import AuthenticatorReducer from './AuthenticatorReducer';

export const AuthenticatorReducers = {
  AuthenticatorReducer,
};

export withAuthenticator from './withAuthenticator';
export ErrorsMiddleware from './ErrorsMiddleware';
